import React from "react";
import { occasions } from "../../App/Landing/landingContent";
import Reveal from "./Reveal";

export default function Occasions() {
  return (
    <section id="occasions" className="bg-white py-14 lg:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center">
          <p className="text-[11px] font-semibold tracking-[0.18em] uppercase text-brand">Perfect for any occasion</p>
          <h2 className="display mt-2 text-3xl sm:text-4xl">Prints That Make an Impact.</h2>
        </Reveal>
        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
          {occasions.map((o, i) => (
            <Reveal
              key={o.name}
              as="figure"
              anim="zoom"
              delay={i * 90}
              className={`group ${i === occasions.length - 1 ? "col-span-2 sm:col-span-1" : ""}`}
            >
              <div className="overflow-hidden rounded-lg">
                <img
                  src={o.image}
                  alt={o.name}
                  width={500}
                  height={400}
                  loading="lazy"
                  className="h-36 w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105 sm:h-40"
                />
              </div>
              <figcaption className="mt-2 text-center text-lg font-semibold">{o.name}</figcaption>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
